/**
 * Sessão local do usuário autenticado por SENHA.
 *
 * A autenticação real é o cookie JWT HttpOnly (setado pelo backend em
 * /auth/login-senha e enviado automaticamente em requests same-origin). Este
 * módulo só guarda um ESPELHO da sessão (id/nome/papel/precisa_trocar_senha)
 * para a UI/roteamento — nunca guarda a senha. Se o cookie expirar, a API
 * responde 401 e o cliente limpa esta sessão (ver api.ts).
 */
import type { SessaoUsuario } from './types';

const KEY = 'sessaoUsuario';

function ler(): SessaoUsuario | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s && typeof s.nome === 'string' && typeof s.papel === 'string') return s as SessaoUsuario;
  } catch {
    /* JSON inválido → trata como deslogado */
  }
  return null;
}

export const auth = {
  /** Sessão atual (ou null). Nome mantido por compat com o código existente. */
  getLogin(): SessaoUsuario | null {
    return ler();
  },
  setLogin(s: SessaoUsuario) {
    localStorage.setItem(KEY, JSON.stringify(s));
    // Limpa o resíduo do antigo login mockado.
    localStorage.removeItem('mockUser');
  },
  /** Atualiza só o flag de troca de senha (após trocar). */
  marcarSenhaTrocada() {
    const s = ler();
    if (s) localStorage.setItem(KEY, JSON.stringify({ ...s, precisa_trocar_senha: false }));
  },
  logout() {
    localStorage.removeItem(KEY);
    localStorage.removeItem('mockUser');
  },
  isLogged(): boolean {
    return ler() !== null;
  },
};
